// extracted by mini-css-extract-plugin
module.exports = {"ldsRoller":"Loading_ldsRoller__bttX0","lds-roller":"Loading_lds-roller__QUPEx"};